import React, { useEffect, useState } from "react";

import {
  Box,
  Card,
  Typography,
  Button,
  Chip,
} from "@mui/material";

import { keyframes } from "@mui/system";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";

import axios from "api/baseurl";

import { useLocation, useNavigate } from "react-router-dom";
import PostConsultationModal from "./PostConsultationModal";

function PostConsultationPage() {
  const location = useLocation();
const navigate = useNavigate();
  const patientId = location.state?.patientId;

  const patientUserId = location.state?.patientUserId;

  const loginData = JSON.parse(
    localStorage.getItem("loginData")
  );

  const doctorUserId = loginData?.userid;

  const token = loginData?.token;

  const [loading, setLoading] = useState(true);

  const [records, setRecords] = useState([]);

  const [openModal, setOpenModal] = useState(false);

  // ================= FETCH RECORDS =================

  const fetchClinicalRecords = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `/api/clinical/latest-records/${doctorUserId}/${patientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Clinical Records", response.data);

      if (Array.isArray(response.data)) {
        setRecords(response.data);
      } else {
        setRecords([]);
      }
    } catch (error) {
      console.log("Fetch Error", error);

      setRecords([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (doctorUserId && patientId) {
      fetchClinicalRecords();
    } else {
      setLoading(false);
    }
  }, [doctorUserId, patientId]);

  // ================= DECISION COLORS =================

  const getDecisionColor = (decision) => {
    switch (decision) {
      case "RESOLVE":
        return {
          bg: "#E8F5E9",
          color: "#2E7D32",
        };

      case "ESCALATE":
        return {
          bg: "#FFF3E0",
          color: "#EF6C00",
        };

      case "EMERGENCY":
        return {
          bg: "#FFEBEE",
          color: "#C62828",
        };

      case "HOLD":
        return {
          bg: "#E3F2FD",
          color: "#1565C0",
        };

      default:
        return {
          bg: "#F5F5F5",
          color: "#424242",
        };
    }
  };

  // ================= TABLE STYLES =================

  const headerStyle = {
    padding: "16px",
    color: "#fff",
    fontSize: "14px",
    fontWeight: 700,
    textAlign: "left",
    whiteSpace: "nowrap",
    border: "1px solid rgba(255,255,255,0.2)",
  };

  const bodyStyle = {
    padding: "16px",
    fontSize: "14px",
    color: "#333",
    verticalAlign: "top",
    border: "1px solid #E0E0E0",
  };

  // ================= LOADER =================

  const spinAnimation = keyframes`
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  `;

  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  // ================= LOADER UI =================

  if (loading) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(255,255,255,0.8)",
          zIndex: 9999,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 80,
            height: 80,
            animation: `${spinAnimation} 1.5s linear infinite`,
          }}
        >
          {dotPositions.map((pos, index) => (
            <Box
              key={index}
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: "#2e7fae",
                position: "absolute",
                ...pos,
              }}
            />
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Box
        sx={{
          maxWidth: "1400px",
          margin: "0 auto",
          pb: 5,
        }}
      >
        {/* ================= HEADER ================= */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
            mt: 2,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
            <Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 2,
  }}
>
  {/* BACK BUTTON */}
  <Button
    onClick={() => navigate(-1)}
              sx={{
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",

                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <ArrowBackIosNewIcon
                sx={{
                  fontSize: "18px",
                }}
              />
  </Button>
          <Box>
            <Typography
              sx={{
                fontSize: "22px",
                fontWeight: 700,
                color: "#1A237E",
              }}
            >
              Post Consultation
            </Typography>
</Box>
            {/* <Typography
              sx={{
                fontSize: "15px",
                color: "#666",
                mt: 0.5,
              }}
            >
              Clinical consultation records & follow-up management
            </Typography> */}
          </Box>

          <Button
            variant="contained"
            startIcon={<AddCircleRoundedIcon />}
            onClick={() => setOpenModal(true)}
            sx={{
              borderRadius: "14px",
              px: 3,
              py: 1.4,
              textTransform: "none",
              fontWeight: 700,
              fontSize: "12px",
              color: "#fff",
              background:
                "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",

              "&:hover": {
                color: "#fff",
                background:
                  "linear-gradient(135deg, #512DA8 0%, #303F9F 100%)",
              },
            }}
          >
            Create Post Consultation
          </Button>
        </Box>

        {/* ================= TABLE ================= */}
<Typography
  sx={{
    fontSize: "20px",
    fontWeight: 800,
    color: "#111",
    mb: 2,
    ml: 1,
    letterSpacing: "0.3px",
  }}
>
  Patient Name : {records?.[0]?.patientName}
</Typography>
        <Card
          sx={{
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
          }}
        >
          <Box sx={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead
                style={{
                  background:
                    "linear-gradient(135deg, #5E35B1 0%, #3949AB 100%)",
                }}
              >
                <tr>
                  <th style={headerStyle}>Diagnosis</th>

                  <th style={headerStyle}>Medications</th>

                  <th style={headerStyle}>Instructions</th>

                  <th style={headerStyle}>Follow Up</th>

                  <th style={headerStyle}>Decision</th>

                  <th style={headerStyle}>
                    Escalation Reason
                  </th>

                  <th style={headerStyle}>
                    Created Date
                  </th>
                </tr>
              </thead>

              <tbody>
                {records?.length === 0 ? (
                  <tr>
                    <td
                      colSpan={7}
                      style={{
                        padding: "40px",
                        textAlign: "center",
                        fontSize: "22px",
                        fontWeight: 700,
                        color: "#9e9e9e",
                        border: "1px solid #E0E0E0",
                      }}
                    >
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  records.map((item, index) => {
                    const decisionStyle =
                      getDecisionColor(item?.decision);

                    return (
                      <tr key={index}>
                        {/* Diagnosis */}

                        <td style={bodyStyle}>
                          {item?.diagnosis || "-"}
                        </td>

                        {/* Medications */}

                        <td style={bodyStyle}>
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1,
                              flexWrap: "wrap",
                            }}
                          >
                            {item?.medications?.length >
                            0 ? (
                              item.medications.map(
                                (med, idx) => (
                                  <Chip
                                    key={idx}
                                    label={med}
                                    size="small"
                                    sx={{
                                      backgroundColor:
                                        "#EDE7F6",
                                      color:
                                        "#4527A0",
                                      fontWeight: 600,
                                    }}
                                  />
                                )
                              )
                            ) : (
                              <Typography>
                                -
                              </Typography>
                            )}
                          </Box>
                        </td>

                        {/* Instructions */}

                        <td style={bodyStyle}>
                          {item?.instructions || "-"}
                        </td>

                        {/* Follow Up */}

                        <td style={bodyStyle}>
                          {item?.followUp || "-"}
                        </td>

                        {/* Decision */}

                        <td style={bodyStyle}>
                          <Chip
                            label={
                              item?.decision || "-"
                            }
                            sx={{
                              backgroundColor:
                                decisionStyle.bg,

                              color:
                                decisionStyle.color,

                              fontWeight: 700,
                            }}
                          />
                        </td>

                        {/* Escalation Reason */}

                        <td style={bodyStyle}>
                          {item?.escalationReason ||
                            "-"}
                        </td>

                        {/* Created Date */}

                        <td style={bodyStyle}>
                          {item?.createdAt
                            ? new Date(
                                item.createdAt
                              ).toLocaleString()
                            : "-"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </Box>
        </Card>

        {/* ================= MODAL ================= */}

        <PostConsultationModal
          open={openModal}
          handleClose={() => setOpenModal(false)}
          patientId={patientId}
          patientUserId={patientUserId}
          refreshData={fetchClinicalRecords}
        />
      </Box>
    </DashboardLayout>
  );
}

export default PostConsultationPage;